import React from "react";
import { connect } from "react-redux";
import { Input } from "../Input";
import { Button } from "../Button";
import language from "../../language";
import icons from "../../constants/icons";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import api from "../../utils/api";
class ChangePassword extends React.Component {
  state = {
    confirmPassword: "",
    password: "",
    error: {},
    otpSent: false,
  };

  onChangeText(field, e) {
    let { error } = this.state;
    delete error[field];

    this.setState({
      [field]: e.target.value,
      error,
    });
  }

  validateForm = () => {
    let { error, password, confirmPassword } = this.state;

    if (password === "") {
      error.password = language[this.props.defaultLanguage].password_required;
    }

    if (confirmPassword !== password) {
      error.password = language[this.props.defaultLanguage].password_not_match;
    }

    this.setState({ error });
  };

  sendOTP = async (e) => {
    e.preventDefault();
    await this.validateForm();

    if (Object.keys(this.state.error).length === 0) {
      this.setState({ isSendingOtp: true });

      const { email } = this.state;

      const options = {
        method: "POST",
        url: `${api("account")}/otp`,
        data: {
          email,
        },
      };

      axios(options)
        .then((data) => {
          this.setState({
            isSendingOtp: false,
            otpSent: true,
            otp: "",
          });

          toastMessage(
            "success",
            language[this.props.defaultLanguage].otp_resent_successfully
          );
        })
        .catch((error) => {
          this.setState({ isSendingOtp: false });

          toastMessage(
            "error",
            this.state.email +
              ", " +
              language[this.props.defaultLanguage].account_not_exist
          );
        });
    }
  };

  passwordRecovery = async (e) => {
    e.preventDefault();
    await this.validateForm();

    if (Object.keys(this.state.error).length === 0) {
      this.setState({ isRecoveringPassword: true });

      const { email, otp, newPassword } = this.state;

      const options = {
        method: "POST",
        url: `${api("account")}/recovery`,
        data: {
          email,
          otp,
          newPassword,
        },
      };

      axios(options)
        .then((data) => {
          this.setState({
            isRecoveringPassword: false,
          });

          toastMessage(
            "success",
            language[this.props.defaultLanguage].password_recovery_success
          );

          window.location.href = "/login";
        })
        .catch((error) => {
          this.setState({ isRecoveringPassword: false });

          toastMessage(
            "error",
            language[this.props.defaultLanguage].password_recovery_error
          );
        });
    }
  };

  render() {
    return (
      <>
        <div className="row">
          <div className="col-md-4">
            <form>
              <Input
                label={language[this.props.defaultLanguage].new_password}
                placeholder={
                  language[this.props.defaultLanguage].new_password_placeholder
                }
                required
                leftIcon={icons.password}
                value={this.state.newPassword}
                error={this.state.error.newPassword}
                onChange={(e) => this.onChangeText("newPassword", e)}
                type="password"
              />
              <Input
                label={language[this.props.defaultLanguage].confirm_password}
                placeholder={
                  language[this.props.defaultLanguage]
                    .confirm_password_placeholder
                }
                required
                leftIcon={icons.password}
                value={this.state.confirmPassword}
                error={this.state.error.confirmPassword}
                onChange={(e) => this.onChangeText("confirmPassword", e)}
                type="password"
              />
              {this.state.otpSent && (
                <>
                  <Input
                    label={language[this.props.defaultLanguage].otp_code}
                    placeholder={
                      language[this.props.defaultLanguage].otp_code_placeholder
                    }
                    required
                    leftIcon={icons.pin}
                    value={this.state.otp}
                    error={this.state.error.otp}
                    onChange={(e) => this.onChangeText("otp", e)}
                    type="number"
                    maxLength={5}
                  />
                </>
              )}
              <Button
                text={language[this.props.defaultLanguage].submit}
                isSubmitting={
                  this.state.otpSent
                    ? this.state.isRecoveringPassword
                    : this.state.isSendingOtp
                }
                onPress={
                  this.state.otpSent
                    ? this.passwordRecovery.bind(this)
                    : this.sendOTP.bind(this)
                }
              />
            </form>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ChangePassword);
